import axios from 'axios';

import {
  authStatusReceived,
  authRequested,
  authRequestCompleted,
  authError,
  authLoggedOut
} from 'RLX/State/Auth/AuthCreators';
import { handleError } from 'RLX/State/Ui/UiActions';

import RLXStore from 'RLX/State/Store';
import { SERVER_URL } from 'RLX/Config';
import { lineBreakSentences } from 'Core/Utils';

export function refreshAuthStatus () {
  return axios.get(SERVER_URL + '/auth')
    .then(({ data = {} }) => RLXStore.dispatch(authStatusReceived(data.user)))
    .catch(error => {
      console.info(error);
      handleError({ ...error, message: `Can't connect to auth service.` });
    });
}

export function attemptLogin ({ email, pass }) {
  RLXStore.dispatch(authRequested());
  return axios.post(SERVER_URL + '/auth', { email, pass })
    .then(res => {
      RLXStore.dispatch(authRequestCompleted());
      RLXStore.dispatch(authStatusReceived(res.data.user));
    })
    .catch(err => handleAuthError(err));
}

export function attemptLogout () {
  RLXStore.dispatch(authRequested());
  return axios.delete(SERVER_URL + '/auth')
    .then(res => {
      RLXStore.dispatch(authRequestCompleted());
      RLXStore.dispatch(authLoggedOut());
    })
    .catch(err => handleAuthError(err));
}


export function attemptRegistration ({ name, email, pass }) {
  RLXStore.dispatch(authRequested());
  axios.post(SERVER_URL + '/auth/register', { name, email, pass })
    .then(res => {
      RLXStore.dispatch(authRequestCompleted());
    })
    .catch(err => handleAuthError(err));
}

export function handleAuthErrorResponse (response) {
  const { data } = response;
  const { message } = data ? data : response;
  dispatchAuthError(message);
};

export function handleAuthError (error, ...loggables) {
  refreshAuthStatus();
  const { response } = error && error.response ? error : { response: error };
  const { data } = response;
  console.error(data, error, ...loggables);
  const { message } = data ? data : response;
  dispatchAuthError(message);
}

export function dispatchAuthError (message) {
  RLXStore.dispatch(authError(lineBreakSentences(message)));
}



// WEBPACK FOOTER //
// ./client/RLX/State/Auth/AuthActions.js